import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/jobFunctions/scheduleDrawingActions'
import * as api from '../../api/job/scheduleDrawings'

function* getScheduleDrawingDates(action) {
  try {
    const payload = yield call(api.getScheduleDrawingDates, action.jobId)
    yield put({ type: constants.GET_SCHEDULE_DRAWING_DATES.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_SCHEDULE_DRAWING_DATES.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetScheduleDrawingDates() {
  yield takeLatest(constants.GET_SCHEDULE_DRAWING_DATES.ACTION, getScheduleDrawingDates)
}

function* sagaUpdateScheduleDrawingDates(action) {
  try {
    const payload = {
      job_id: action.jobId,
      schedule_id: action.scheduleId,
      content: action.content,
      updated_by_id: action.userId,
      type: action.scheduleType,
      description: action.description,
      due_date: action.content[action.scheduleType],
      assigned_to_id: 1,
      user_id: 1
    }
    yield call(api.updateScheduleDrawingDates, payload)
    yield put({ type: constants.SCHEDULE_DRAWING_UPDATE.SUCCESS, payload })
    yield call(getScheduleDrawingDates, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.SCHEDULE_DRAWING_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateScheduleDrawing() {
  yield takeLatest(constants.SCHEDULE_DRAWING_UPDATE.ACTION, sagaUpdateScheduleDrawingDates)
}

function* sagaUpdateScheduleDrawingNotes(action) {
  try {
    const payload = {
      job_id: action.jobId,
      notes: action.notes,
      updated_by_id: action.userId,
      user_id: 1
    }
    yield call(api.updateScheduleDrawingNotes, payload)
    yield put({ type: constants.SCHEDULE_DRAWING_UPDATE_NOTE.SUCCESS, payload })
    yield call(getScheduleDrawingDates, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.SCHEDULE_DRAWING_UPDATE_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateScheduleDrawingNotes() {
  yield takeLatest(constants.SCHEDULE_DRAWING_UPDATE_NOTE.ACTION, sagaUpdateScheduleDrawingNotes)
}

function* sagaAddScheduleDrawingDate(action) {
  try {
    const payload = {
      job_id: action.jobId,
      updated_by_id: action.userId,
      created_by_id: action.userId,
      user_id: action.userId,
      schedule_id: action.scheduleId
    }

    yield call(api.addScheduleDrawingDates, payload)
    yield put({ type: constants.ADD_SCHEDULE_DRAWING_DATE.SUCCESS, payload })
    yield call(getScheduleDrawingDates, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.ADD_SCHEDULE_DRAWING_DATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchAddScheduleDrawingDate() {
  yield takeLatest(constants.ADD_SCHEDULE_DRAWING_DATE.ACTION, sagaAddScheduleDrawingDate)
}

function* sagaDeleteScheduleDrawing(action) {
  try {
    const payload = {
      schedule_id: action.scheduleId
    }
    yield call(api.deleteScheduleDrawing, payload)
    yield put({ type: constants.DELETE_SCHEDULE_DRAWING.SUCCESS, payload })
    yield call(getScheduleDrawingDates, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_SCHEDULE_DRAWING.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteScheduleDrawing() {
  yield takeLatest(constants.DELETE_SCHEDULE_DRAWING.ACTION, sagaDeleteScheduleDrawing)
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchGetScheduleDrawingDates),
    fork(watchUpdateScheduleDrawing),
    fork(watchUpdateScheduleDrawingNotes),
    fork(watchAddScheduleDrawingDate),
    fork(watchDeleteScheduleDrawing)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/scheduleDrawingSaga.js